module.exports = __webpack_public_path__ + "static/media/Water Award.3ec7b0b5.svg";